export default __webpack_public_path__ + "static/media/colorimage.af7e9ac0.jpg";